export default __webpack_public_path__ + "static/20-3227afdcdebec5648d99d8fb7513ba92.png";